import * as React from "react";
import ZoomIn from "material-ui/svg-icons/action/zoom-in";
import ZoomOut from "material-ui/svg-icons/action/zoom-out";
import FlatButton from "material-ui/FlatButton";

class NavegadorImagen extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    render() {
        return(
            <div>
                {this.ZoomOutBtn()}
                {this.ZoomInBtn()}
            </div>
        );
    }

    ZoomOutBtn() {
        if (this.props.zoomImage === '70%') {
            return (
                <FlatButton
                    icon={<ZoomOut/>}
                    disabled
                />
            );
        }
        return (
            <FlatButton
                icon={<ZoomOut/>}
                onClick={this.props.eventZoomOutImage}
            /> 
        ); 
    }

    ZoomInBtn() {
        if (this.props.zoomImage === '130%') {
            return (
                <FlatButton
                    icon={<ZoomIn/>}
                    disabled
                />
            );
        }
        return (
            <FlatButton
                icon={<ZoomIn/>}
                onClick={this.props.eventZoomInImage}
            />
        );
    }
}

export default NavegadorImagen;


// WEBPACK FOOTER //
// ./src/co/sura/dominio/documentos/componentes/NavegadorImagen.tsx